import React from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { PUBLIC_URL } from './config/settings/environment'
import routes from './config/settings/routes'
import NotFoundPage from './pages/NotFound'
import BuyerCardPage from './pages/BuyerCard'
import DownloadPage from './pages/DownloadPDF.jsx'

/**
 * The Routing' component.
 */
const Routing = () => (
  <BrowserRouter basename={PUBLIC_URL}>
    <Routes>
      <Route caseSensitive element={<BuyerCardPage />} path={routes.generalInformation} />
      <Route caseSensitive element={<BuyerCardPage />} path={routes.buyerCard} />
      <Route caseSensitive element={<BuyerCardPage />} path={routes.annualPurchasingPlan} />
      <Route caseSensitive element={<BuyerCardPage />} path={routes.purchaseOrders} />
      <Route caseSensitive element={<BuyerCardPage />} path={routes.claims} />
      <Route caseSensitive element={<BuyerCardPage />} path={routes.courtLawsuits} />
      <Route caseSensitive element={<BuyerCardPage />} path={routes.behavior} />
      <Route caseSensitive element={<DownloadPage />} path={routes.downloadpdf} />
      <Route element={<NotFoundPage />} path="*" />
    </Routes>
  </BrowserRouter>
)

export default Routing
